<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import OcupationalMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalMedicineAPI";
import Swal from "sweetalert2";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CheckModal from "@/components/CheckModal"
import Switches from "vue-switches";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"

/**
 * Form elements component
 */
export default {
  page: {
    title: "3.1.4 Evaluaciones médicas ocupacionales",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    Switches,
    PageHeader,
  },
  data() {
    return {
      title: "3.1.4 Evaluaciones médicas ocupacionales",
      items: [

        {
          text: "Estándares",
          href: "/forms/estandares",
        },
        {
          text: "Medicina Ocupacional",
          active: true,
        },
      ],

      company: "",

      company: this.$store.getters["company/getCompany"] || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      userSelected: null,
      company: this.$store.getters["company/getCompany"] || null,
      usersList: [],
      guardando: false,
      loading1: true,
      itemData: null,

      file: null,

      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        exam_status: null,
      },

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso"
        },
        {
          id: 2,
          name: "Exámenes periódicos"
        },
        {
          id: 3,
          name: "examen de retiro"
        },
        {
          id: 4,
          name: "examen post incapacidad"
        },
        {
          id: 5,
          name: "examen por cambio de ocupación"
        }
      ],

    };
  },
  methods: {

    saludar: function (event) {
      Swal.fire({
        icon: 'info',
        title: "Éxito",
        type: "warning",
        confirmButtonClass: "btn btn-confirm mt-2",
        text: 'Por favor verifique todos los examenes para medicina ocupacional de' + ' ' + this.$store.getters["company/getCompany"].social_reason || null,
      });
    },

    getItemData() {
      ItemAPI.getItems(26)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
   * This method is used to knows if the user has the permission indicated
   * @param {String} name The name of the permission
   * @param {Array} roles the roles that permitted to access the action 
   * @returns {Boolean} true if the user has the permission indicated or false if no
   */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let name = "";
        let url = "";

        // Si no hay un archivo nuevo seleccionado, usamos el archivo existente en this.ocupationalMedicine.file
        if (this.file === null) {
          // Comprobamos si ya existe un archivo en ocupationalMedicine.file
          if (this.ocupationalMedicine.file) {
            // Mantener el archivo existente
            name = this.getFile(this.ocupationalMedicine.file);
          } else {
            // Si no hay archivo existente ni uno nuevo, no hacemos nada
            throw new Error("No se ha seleccionado un archivo y no hay un archivo previo.");
          }
        } else {
          // Si se selecciona un nuevo archivo, usamos el nombre del nuevo archivo
          name = this.file.name;
        }

        // Definir la URL basada en el entorno (desarrollo o producción)
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/3.1.4/${this.ocupationalMedicine.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/3.1.4/${this.ocupationalMedicine.employee_id}/${name}`;
        }

        // Si no se seleccionó un archivo nuevo, simplemente regresamos true
        if (this.file === null) {
          // Mantener la referencia al archivo existente en this.ocupationalMedicine.file
          return true;
        } else {
          // Cargar el nuevo archivo
          const result = await uploadDocument(url, this.file);
          if (result) {
            // Si la carga es exitosa, actualizar la URL del archivo en this.ocupationalMedicine.file
            this.ocupationalMedicine.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else {
            return false;
          }
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    getMedicine() {
      OcupationalMedicineAPI.getMedicine(this.$route.params.id)
        .then((response) => {
          this.loading1 = false
          this.ocupationalMedicine = {
            id: response.id,
            exam_date: response.exam_date,
            file: response.file,
            exam_cycles_id: response.exam_cycles_id,
            employee_id: response.employee_id,
            exam_status: response.exam_status,
          };
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    async update() {
      this.guardando = true
      this.loading1 = true
      let document = await this.uploadDocument();
      if (document) {
        OcupationalMedicineAPI.updateMedicine(this.$route.params.id, {
          id: this.ocupationalMedicine.id,
          exam_date: this.ocupationalMedicine.exam_date,
          file: this.ocupationalMedicine.file,
          exam_cycles_id: this.ocupationalMedicine.exam_cycles_id,
          employee_id: this.ocupationalMedicine.employee_id,
          exam_status: this.ocupationalMedicine.exam_status,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 26,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha actualizado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          }).catch((err) => {
            console.log(err);
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 2000)
      }
    },

    getUsers() {
      CompanyAPI.getCompany(this.$route.params.companies_id)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.loading1 = false
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
          this.loading1 = false
        });
    },

    goBack() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.getUsers();
    this.getMedicine()
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading1">

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá realizar evaluaciones periódicas del estado de salud de sus colaboradores,
                      para esto se informa al médico que realiza las evaluaciones ocupacionales los perfiles del cargo,
                      con una descripción de las tareas y el medio en el cual se desarrollará la labor respectiva; esta
                      evaluación
                      deberá ser adelantada por médicos profesionales en medicina laboral.
                    </p>

                  </CheckModal>
                </div>

                <div class="col-6 text-right">
                  <div @click="goBack" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
                </div>

              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">

                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required class="form-control"
                      v-model="ocupationalMedicine.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Fecha examen" label-for="date">
                    <b-form-input :disabled="!getRole('Editar') || !allowAccess()" type="date" id="date"
                      v-model="ocupationalMedicine.exam_date">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="cycle" class="col-md-6 px-2" label="Ciclo de examen">
                    <select :disabled="!getRole('Editar') || !allowAccess()" class="form-control"
                      v-model="ocupationalMedicine.exam_cycles_id">
                      <b-form-select-option v-for="item in list" :key="item.id" :value="item.id">
                        {{ item.name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Editar') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="ocupationalMedicine.file ? getFile(ocupationalMedicine.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <label class="mr-3">
                    <input type="checkbox" id="example-2" v-on:click="saludar"
                      :disabled="!getRole('Editar') || !allowAccess()" v-model="ocupationalMedicine.exam_status"> Estado
                    del examen
                  </label>
                  <button :disabled="guardando" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr />
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
